exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image-icon img {\n  max-width: 100%;\n  vertical-align: middle; }\n", ""]);

// exports
